import React from "react";
import "./index.css";

function BillingHistory() {
  return <h1>Billing History</h1>;
}

export default BillingHistory;
